export var PUBLIC_STATUS_LABEL = {
    RECEIVED: "Recebido",
    IN_ANALYSIS: "Em Análise",
    IN_INSPECTION: "Em Fiscalização",
    COMPLETED: "Concluído",
    ARCHIVED: "Arquivado",
};
export var PUBLIC_STATUS_STEP = {
    RECEIVED: 0,
    IN_ANALYSIS: 1,
    IN_INSPECTION: 2,
    COMPLETED: 3,
    ARCHIVED: 3,
};
export var STEPPER_STATUSES = [
    "RECEIVED",
    "IN_ANALYSIS",
    "IN_INSPECTION",
    "COMPLETED",
];
export var STEPPER_STEP_LABELS = STEPPER_STATUSES.map(function (s) { return PUBLIC_STATUS_LABEL[s]; });
